import React, { FC, useState } from 'react'
import { Button, Icon, Modal } from 'antd'
import { handleError } from '..'
import { serviceProviderService } from '../../services'
import RequestError from '../../services/RequestError'
import { RequestErrorObject, ServiceProvider, SingleResponse } from '../../types'
import TemplateIdForm from './TemplateIdForm'

interface RecurringInvoiceActionsProps {
	entity: ServiceProvider
}

const RecurringInvoiceActions: FC<RecurringInvoiceActionsProps> = ({ entity }) => {
	const [serviceProvider, setServiceProvider] = useState<ServiceProvider>(entity)
	const [modalIsVisible, setModalAsVisible] = useState(false)

	const updateTemplate = async (newTemplateId: string) => {
		const createError = (error: RequestError): RequestErrorObject => {
			const source = 'Update TemplateId'
			const base = { status: error.response.status, source }
			return { ...base, description: `There was an unexpected error when attempting to amend the Template Id for ${serviceProvider.name}` }
		}

		try {
			const response: SingleResponse<ServiceProvider> = await serviceProviderService.updateTemplateIdForServiceProvider(serviceProvider.id, newTemplateId)
			setServiceProvider(response.data)
			setModalAsVisible(false)
		} catch (error) {
			handleError(error, createError)
		}
	}

	const isTemplateIdSet: boolean = serviceProvider.template_id && serviceProvider.template_id.length > 0

	return (
		<div style={{ textAlign: 'right' }}>
			<Button.Group>
				<Button href={serviceProvider.template_url} target='_blank' rel='noreferrer' disabled={!isTemplateIdSet}>
					<Icon type='link' /> Open Recurring Invoice
				</Button>
				<Button type='link' onClick={() => setModalAsVisible(true)}>
					<Icon type='edit' /> Edit
				</Button>
			</Button.Group>
			<Modal visible={modalIsVisible} title='Enter new Recurring Invoice Id' onCancel={() => setModalAsVisible(false)} footer={false} width={300}>
				<TemplateIdForm templateId={serviceProvider.template_id} updateTemplate={updateTemplate} />
			</Modal>
		</div>
	)
}

export default RecurringInvoiceActions
